import { vdmContracts } from "./vdm.contract";
import { edi844SubmissionsContracts } from "./edi844-submissions.contract";

export const shipAndDebitContracts = {
  vdms: vdmContracts,
  edi844Submissions: edi844SubmissionsContracts,
} as const;

export * from "./vdm.contract";
export * from "./edi844-submissions.contract";
